import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();
    return object().shape({
        contact: string().required(REQUIRED_TEXT).nullable(),
        contact_name: string().when('contact', {
            is: 'new_contact',
            then: () => string().required(REQUIRED_TEXT).nullable(),
        }),
        latitude: string().required(REQUIRED_TEXT).nullable(),
        longitude: string().required(REQUIRED_TEXT).nullable(),
        name: string().required(REQUIRED_TEXT).nullable(),
    });
};
